/**
 * loaderHandler
 *
 * The loaderHandler provides methods for staring/stoping of the loader overlay.
 */
export default function loaderHandler () {
  return {
    methods: {
      startLoader () {
        if (window.$vue3?.loader) {
          window.$vue3.loader.startLoader()
        } else {
          // We need this functionality, because the loader is sometimes not available in the Vue components on mounted/created hooks (it's not yet loaded)
          // Retry until window.$vue3.loader exists
          const checkLoader = setInterval(() => {
            if (window.$vue3?.loader) {
              window.$vue3.loader.startLoader()
              clearInterval(checkLoader) // Stop checking once found
            }
          }, 100)
        }
      },
      stopLoader (callback) {
        if (window.$vue3?.loader) {
          window.$vue3.loader.stopLoader(callback)
        } else {
          // We need this functionality, because the loader is not available in the Vue components on mounted/created hooks (it's not yet loaded)
          // Retry until window.$vue3.loader exists
          const checkLoader = setInterval(() => {
            if (window.$vue3?.loader) {
              window.$vue3.loader.stopLoader()
              clearInterval(checkLoader) // Stop checking once found
            }
          }, 100)
        }
      }
    }
  }
}
